import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, signal, computed } from '@angular/core';
import { catchError, finalize, map, tap, throwError } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../app.config';
import { LoadingService } from './loading.service';
import { ToastService } from './toast.service';
import { ErrorService } from './error.service';
import { IPayload, UIRequest } from './base/policy-details';
import { IField } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    paymentDetails = signal<IPayload | null>(null);
    randomChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    httpOptions = {
        headers: new HttpHeaders({
            'x-api-key': this.config.guestPayApiKey,
        }),
    };
    selectedPaymentDue = signal<IField | null>(null);
    otherPayment = signal<number | null>(null);

    constructor(
        private router: Router,
        private http: HttpClient,
        private errorService: ErrorService,
        private loader: LoadingService,
        @Inject(APP_CONFIG) private config: AppConfig,
        private toastService: ToastService
    ) {
        this.setPaymentDetails();
    }

    updatePaymentDetails(payload: IPayload | null) {
        this.paymentDetails.update(current => ({
            ...current,
            ...(payload || {})
        } as IPayload));
    }

    getPaymentDetails() {
        if (!this.paymentDetails() && !this.config.useMock) {
            this.router.navigate(['/paymentportal']);
        }
        return this.paymentDetails();
    }

    setPaymentDetails() {
        if (this.config.useMock) {
            const url = 'assets/local_data/payment-details.json';
            this.http.get<any>(url)
                .pipe(
                    tap((ret: any) => this.updatePaymentDetails(ret.payload))
                ).subscribe();
        }
    }

    generateRandomString() {
        const array = new Uint32Array(1);
        let result = '';
        for (let i = 0; i < 15; i++) {
            crypto.getRandomValues(array);
            result += this.randomChars.charAt(array[0] % this.randomChars.length);
        }
        return result;
    }

    callPaymentService(payload: IPayload, serviceName: string) {
        let url = '';
        let body: UIRequest = {} as UIRequest;
        
        if (this.config.useMock) {
            url = `assets/local_data/payment-details.json`;
            return this.http.get<any>(url)
                .pipe(
                    tap((ret: any) => {
                        this.updatePaymentDetails(ret.payload);
                    }),
                );
        } else {
            body.reqId = this.generateRandomString();
            body.serviceName = serviceName;
            body.payload = {
                ...payload,
                applicationSource: 'GPP'
            };
            url = this.config.guestPayService;
            
            this.loader.showLoading();
            return this.http.post<any>(url, body, this.httpOptions)
                .pipe(
                    tap((ret: any) => {
                        if (ret.statusCode && ret.statusCode == 200) {
                            this.updatePaymentDetails(ret.payload);
                        } else {
                            this.toastService.add({
                                type: 'error',
                                title: 'Error',
                                message: 'Our system is struggling, Please try again',
                            });
                        }
                    }),
                    catchError((error: HttpErrorResponse) => {
                        this.toastService.add({
                            type: 'error',
                            title: 'Error',
                            message: 'Our system is struggling, Please try again',
                        });
                        this.errorService.handleError(error);
                        return throwError(() => error);
                    }),
                    finalize(() => {
                        this.loader.hideLoading();
                    })
                );
        }
    }

    getPaymentData(request: any) {
        request = {
            ...request,
            applicationSource: 'GPP'
        };
        return this.http.post(this.config.paymentURL, request).pipe(
            tap((data) => { }),
            map((data: any) => {
                return data;
            }),
            catchError((error: HttpErrorResponse) => {
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: 'Our system is struggling, Please try again',
                });
                this.errorService.handleError(error);
                return throwError(() => error);
            })
        );
    }
    
}
